module.exports = __webpack_public_path__ + "img/revolving-hearts.8dce0da6.png";